type Row = Record<string, unknown>
const claims = new WeakMap<object, Map<string, symbol>>()
const row = (value: unknown): Row | undefined =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Row)
    : undefined

export function findListRow(
  data: unknown,
  id: string,
  listItemsKey?: string,
): Row | undefined {
  const envelope = row(data)
  const rows = Array.isArray(data)
    ? data
    : (envelope?.data ?? (listItemsKey ? envelope?.[listItemsKey] : undefined))
  return Array.isArray(rows)
    ? (rows.find(item => row(item)?.id === id) as Row | undefined)
    : undefined
}

/** Weak ownership metadata never enters records, persistence or realtime payloads. */
export function claimOptimisticField(
  value: unknown,
  field: string,
  token: symbol,
): void {
  const record = row(value)
  if (!record) return
  let fields = claims.get(record)
  if (!fields) {
    fields = new Map()
    claims.set(record, fields)
  }
  fields.set(field, token)
}

export function ownsOptimisticField(
  current: unknown,
  expected: unknown,
  field: string,
  token: symbol,
): boolean {
  const record = row(current)
  return (
    !!record &&
    record === row(expected) &&
    claims.get(record)?.get(field) === token
  )
}

export function restoreOptimisticField(
  current: unknown,
  previous: unknown,
  expected: unknown,
  field: string,
  token: symbol,
): unknown {
  const before = row(previous),
    record = row(current),
    optimistic = row(expected)
  if (
    !before ||
    !record ||
    !ownsOptimisticField(record, optimistic, field, token)
  )
    return current
  const restored = { ...record }
  if (Object.prototype.hasOwnProperty.call(before, field))
    restored[field] = before[field]
  else delete restored[field]
  return restored
}
